var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIconOfNavigationbar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3178_117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3178_117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 25.0001C50 38.8075 38.8074 50.0002 24.9999 50.0002C11.1925 50.0002 0 38.8075 0 25.0001C0 11.1928 11.1926 0 24.9999 0C38.8073 0 50 11.1928 50 25.0001Z",
    fill: "#3A5686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 25C26.1867 25 27.3467 24.6481 28.3334 23.9888C29.3201 23.3295 30.0892 22.3925 30.5433 21.2961C30.9974 20.1997 31.1162 18.9933 30.8847 17.8295C30.6532 16.6656 30.0818 15.5965 29.2426 14.7574C28.4035 13.9182 27.3344 13.3468 26.1705 13.1153C25.0067 12.8838 23.8003 13.0026 22.7039 13.4567C21.6075 13.9109 20.6705 14.6799 20.0112 15.6666C19.3519 16.6533 19 17.8133 19 19C18.9998 19.788 19.1548 20.5683 19.4563 21.2964C19.7577 22.0244 20.1997 22.6859 20.7569 23.2431C21.3141 23.8003 21.9756 24.2423 22.7036 24.5437C23.4317 24.8452 24.212 25.0002 25 25ZM25 28C20.995 28 13 30.01 13 34V37H37V34C36.9999 30.01 29.0049 28 25 28Z",
    fill: "#F9F9F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconOfNavigationbar);
export default __webpack_public_path__ + "static/media/profile_icon_of_navigationbar.c2515424491465a3b0378f92e72577e0.svg";
export { ForwardRef as ReactComponent };